export default __webpack_public_path__ + "static/media/cfjp04.e4ce96ca.png";